@file:OptIn(InternalResourceApi::class)

package ltd.cloudgrid.components.preview.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ltd.cloudgrid.components.preview.generated.resources/"

@delegate:ResourceContentHash(65_105_017)
internal val Res.drawable.ic_arrow_right_alt: DrawableResource by lazy {
      DrawableResource("drawable:ic_arrow_right_alt", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_arrow_right_alt.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(421_908_191)
internal val Res.drawable.ic_check_circle: DrawableResource by lazy {
      DrawableResource("drawable:ic_check_circle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_check_circle.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_arrow_right_alt", Res.drawable.ic_arrow_right_alt)
  map.put("ic_check_circle", Res.drawable.ic_check_circle)
}
